import React from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import Stack from '@mui/material/Stack';

interface Props {
  label?: string;
  loading?: boolean;
}

export default function ButtonLoader(props: Props) {
  const { label, loading = false } = props;

  return (
    <React.Fragment>
      {loading && (
        <Stack
          position="absolute"
          left={0}
          top={0}
          width="100%"
          height="100%"
          display="flex"
          alignItems="center"
          justifyContent="center"
        >
          <CircularProgress size="1em" color="inherit" />
        </Stack>
      )}
      <span style={{ visibility: loading ? 'hidden' : 'visible' }} className="MuiButton-label">
        {label}
      </span>
    </React.Fragment>
  );
}
